import { CourseOffering } from '../models/course-offering.model';

export class AddCourseOfferings {
    static readonly type = '[CourseOffering] AddCourseOfferings';

    constructor(public payload: CourseOffering[]) {}
}
